module.exports = __webpack_public_path__ + "static/Silver_Dragon-7c8489333f7845db33519191e04de57b.jpg";